import { Percent } from '@mui/icons-material';
import BackspaceIcon from '@mui/icons-material/Backspace';
import { DialogActions, DialogContent, DialogTitle, Icon, IconButton, TextField } from '@mui/material';
import CustomDialog from 'components/custom/CustomDialog';
import { CustomButton } from 'components/roundedbutton/CustomButton';
import HeaderOuBannerDependendoDaInterpretacaoH1 from 'layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1';
import { FormEvent, useRef, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { theme } from 'theme';

type Props = {
    open: boolean;
    onConfirm: (value: number) => void;
    onClose: () => void;
    onClear: () => void;
    onFocus?: () => void;
    percentual: number;
    onChangeDesconto?: (value: number | undefined) => void;
};

const FixarDescontoDialog = (props: Props) => {

    const descontoFixoTempRef = useRef<HTMLInputElement>(null);
    const [valueLocal, setValueLocal] = useState(props.percentual);
    const [openAnterior, setOpenAnterior] = useState(props.open);

    // O diálogo fica montado o tempo todo, então o estado local precisa ser ressincronizado a cada
    // abertura — senão reabre com o valor digitado numa tentativa anterior (ex.: desconto recusado
    // pelo supervisor). O ajuste é feito durante o render para o campo nunca exibir, nem por um
    // frame, o valor descartado.
    if (props.open !== openAnterior) {
        setOpenAnterior(props.open);
        if (props.open) setValueLocal(props.percentual);
    }

    const localConfirm = (e: FormEvent) => {
        e.preventDefault();
        props.onConfirm(valueLocal);
    };

    const localClear = () => {
        props.onClear();
        setValueLocal(0);
    };

    const handleChangeValor = (value: number | undefined) => {
        props.onChangeDesconto?.(value);
        setValueLocal(value ?? 0);
    };

    return <CustomDialog
        id="desconto-fixo-dialog"
        open={props.open}
        onClose={props.onClose}
        onFocus={() => props.onFocus?.() ?? descontoFixoTempRef.current?.focus()}
    >

        <form onSubmit={localConfirm}>
            <DialogTitle id="alert-dialog-title" textAlign={'center'}>
                <HeaderOuBannerDependendoDaInterpretacaoH1
                    id='consulta-estoque'
                    iconClassName='fa-solid fa-percent'
                    label={"Fixar desconto no item"}
                    small
                />
            </DialogTitle>

            <DialogContent sx={{ height: 'auto', display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
                <NumericFormat
                    id='fixar-desconto-input'
                    onFocus={() => descontoFixoTempRef.current?.setSelectionRange(1, 1)}
                    style={{ width: '13rem', }}
                    decimalScale={2}
                    fixedDecimalScale
                    defaultValue={0}
                    allowedDecimalSeparators={[',']}
                    customInput={TextField}
                    decimalSeparator=","
                    thousandsGroupStyle="thousand"
                    thousandSeparator="."
                    variant="standard"
                    allowNegative={false}
                    inputProps={{ style: { textAlign: 'center', fontSize: '24px', color: theme.palette.text.primary, fontWeight: 700, fontFamily: 'Work Sans, sans-serif' } }}
                    isAllowed={({ floatValue }) => !floatValue || floatValue <= 100}
                    value={valueLocal}
                    inputRef={descontoFixoTempRef}
                    onValueChange={({ floatValue }) => handleChangeValor(floatValue)}
                    InputProps={{
                        endAdornment: (
                            <IconButton>
                                <Percent style={{ color: theme.palette.primary.main }} />
                            </IconButton>
                        )
                    }}
                />
            </DialogContent>

            <DialogActions
                sx={{
                    justifyContent: 'space-between'
                }}>
                <CustomButton
                    id='fixar-desconto-limpar-btn'
                    onClick={localClear}
                    variant="contained"
                    color='secondary'
                    startIcon={<BackspaceIcon />}>
                    Limpar
                </CustomButton>

                <CustomButton
                    id='fixar-desconto-salvar-btn'
                    type="submit"
                    variant="contained"
                    color="success"
                    startIcon={<Icon className='fa-solid fa-check' />}>
                    Salvar
                </CustomButton>
            </DialogActions>
        </form>
    </CustomDialog>;
};

export default FixarDescontoDialog;
